"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var Version = 0.4;
var BI_ENDPOINT = "https://bi.orbs.network/putes/twap-ui-".concat(Version);
function generateId() {
    var part1 = Math.random().toString(36).substring(2, 16); // Generate 16 random characters
    var part2 = Math.random().toString(36).substring(2, 16); // Generate another 16 random characters
    var timestamp = Date.now().toString(36); // Generate a timestamp
    return "id_".concat(part1 + part2 + timestamp); // Concatenate all parts
}
var sendBI = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(BI_ENDPOINT, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    }).then()];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error("Failed to send BI", error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.timeout = undefined;
        this.data = {
            _id: generateId(),
        };
    }
    Analytics.prototype.updateAndSend = function (values, noTimeout) {
        var _this = this;
        if (values === void 0) { values = {}; }
        if (noTimeout === void 0) { noTimeout = false; }
        this.data = __assign(__assign({}, this.data), values);
        if (noTimeout) {
            sendBI(this.data);
        }
        else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                sendBI(_this.data);
            }, 1000);
        }
    };
    Analytics.prototype.onCancelOrder = function (orderId) {
        this.updateAndSend({
            cancelOrderId: orderId,
            action: "cancel order",
        });
    };
    Analytics.prototype.onCancelOrderSuccess = function () {
        this.updateAndSend({
            cancelOrderSuccess: true,
        });
    };
    Analytics.prototype.onCanelOrderError = function (error) {
        this.onTxError(error);
    };
    Analytics.prototype.onWrapSuccess = function (wrapTxHash) {
        this.updateAndSend({
            wrapTxHash: wrapTxHash,
        });
    };
    Analytics.prototype.onWrapRequest = function () {
        this.updateAndSend({
            action: "wrap",
        });
    };
    Analytics.prototype.onWrapError = function (error) {
        this.onTxError(error);
    };
    Analytics.prototype.onApproveRequest = function () {
        this.updateAndSend({
            action: "approve",
        });
    };
    Analytics.prototype.onApproveSuccess = function (approvalTxHash) {
        this.updateAndSend({
            approvalTxHash: approvalTxHash,
        });
    };
    Analytics.prototype.onApproveError = function (error) {
        this.onTxError(error);
    };
    Analytics.prototype.onCreateOrderError = function (error) {
        this.onTxError(error);
    };
    Analytics.prototype.onTxError = function (error) {
        var _a;
        var actionError = ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (error === null || error === void 0 ? void 0 : error.toLowerCase());
        this.updateAndSend({ actionError: actionError });
    };
    Analytics.prototype.onCreateOrderRequest = function (askParams, account) {
        var values = askParams;
        var fromTokenAmount = values[3];
        var srcChunkAmount = values[4];
        var chunksAmount = (0, bignumber_js_1.default)(fromTokenAmount).div(srcChunkAmount).integerValue(bignumber_js_1.default.ROUND_FLOOR).toNumber();
        this.updateAndSend({
            fromTokenAddress: values[1],
            toTokenAddress: values[2],
            fromTokenAmount: values[3],
            chunksAmount: chunksAmount,
            minDstAmountOut: values[5],
            deadline: values[6],
            fillDelay: values[8],
            srcChunkAmount: srcChunkAmount,
            action: "create order",
            walletAddress: account,
            orderSubmitted: true,
        });
    };
    Analytics.prototype.onConfigChange = function (config) {
        var _a;
        if (config.partner !== ((_a = this.data) === null || _a === void 0 ? void 0 : _a.partner)) {
            this.data = {
                _id: generateId(),
                action: "module-import",
                bidDelaySeconds: config === null || config === void 0 ? void 0 : config.bidDelaySeconds,
                chainId: config === null || config === void 0 ? void 0 : config.chainId,
                chainName: config === null || config === void 0 ? void 0 : config.chainName,
                exchangeAddress: config === null || config === void 0 ? void 0 : config.exchangeAddress,
                exchangeType: config === null || config === void 0 ? void 0 : config.exchangeType,
                lensAddress: config === null || config === void 0 ? void 0 : config.lensAddress,
                name: config === null || config === void 0 ? void 0 : config.name,
                partner: config === null || config === void 0 ? void 0 : config.partner,
                twapAddress: config === null || config === void 0 ? void 0 : config.twapAddress,
                twapVersion: config === null || config === void 0 ? void 0 : config.twapVersion,
            };
            this.updateAndSend(this.data);
        }
    };
    Analytics.prototype.onCreateOrderSuccess = function (createOrderTxHash, newOrderId) {
        var _a;
        this.updateAndSend({
            newOrderId: newOrderId,
            createOrderTxHash: createOrderTxHash,
            orderSuccess: true,
        }, true);
        this.data = {
            _id: generateId(),
            action: "module-import",
            bidDelaySeconds: (_a = this.data) === null || _a === void 0 ? void 0 : _a.bidDelaySeconds,
            chainId: this.data.chainId,
            chainName: this.data.chainName,
            exchangeAddress: this.data.exchangeAddress,
            exchangeType: this.data.exchangeType,
            lensAddress: this.data.lensAddress,
            name: this.data.name,
            partner: this.data.partner,
            twapAddress: this.data.twapAddress,
            twapVersion: this.data.twapVersion,
        };
    };
    Analytics.prototype.onLoad = function () {
        this.updateAndSend({
            action: "module-import",
        }, true);
    };
    return Analytics;
}());
exports.Analytics = Analytics;
